import React from 'react';
import InnerHTML from 'dangerously-set-html-content';
import multivHTML from './multivHTML';
import './index.scss';

const MultiV = () => <InnerHTML html={multivHTML} />;

export default MultiV;
